import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import Header from '../Header';

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 1920px;
  margin: 0 auto;
  padding-left: 0;
  padding-right: 1rem;
  padding-bottom: 2rem;
`;

const InnerContent = styled.div`
  padding: 40px;
  width: 100%;
`;

function Layout() {
  return (
    <>
      <Header />
      <ContentWrapper>
        <InnerContent>
          <Outlet />
        </InnerContent>
      </ContentWrapper>
    </>
  );
}

export default Layout;
